import React from 'react';

import BaseInput from 'component/Layout/Form/Input';

import { ReactComponent as IconChevronRounded } from 'media/svg/chevronRounded.svg';

import styles from '../Location.module.scss';
import { LocationFilterType } from '../types';

interface InputProps {
    type: LocationFilterType;
    placeholder: string;
    onOpen: () => void;
    value: string;
    onValueChange: (value: string) => void;
}

const Input = ({
    type,
    placeholder,
    onOpen,
    value,
    onValueChange,
}: InputProps) => (
    <BaseInput
        input={{
            type: 'text',
            id: type,
            placeholder: placeholder,
            name: type,
            icon: <IconChevronRounded />,
            value: value,
            autoComplete: 'off',
        }}
        customClass={{
            InputWrapper: styles.InputWrapper,
            Icon: styles.Icon,
            Input: styles.Input,
        }}
        onClick={onOpen}
        onChange={onValueChange}
    />
);

export default Input;
